/* eslint-disable no-unused-vars */
import Swiper from 'swiper/swiper-bundle';

/**
 * Initialise sliders
 *
 * @export
 */
export function setupSwipers() {
  Array.from(document.querySelectorAll('.js-swiper-slider')).forEach(
    (slider) => {
      const galleryName = slider.dataset.galleryName;

      const autoplay = slider.dataset.autoplay === 'true';

      const loop = slider.dataset.loop === 'true';

      const freeMode = slider.dataset.freemode === 'true';

      const centeredSlides = slider.dataset.centeredSlides === 'true';

      const effect = slider.dataset.effect ? slider.dataset.effect : 'slide';
      const crossFade = effect === 'fade';

      const speed = slider.dataset.speed
        ? parseInt(slider.dataset.speed, 10)
        : 1000;

      const autoplaySpeed = slider.dataset.autoplaySpeed
        ? parseInt(slider.dataset.autoplaySpeed, 10)
        : 5000;

      const spaceBetween = slider.dataset.spaceBetween
        ? parseInt(slider.dataset.spaceBetween)
        : 0;

      const mobileSpaceBetween = slider.dataset.mobileSpaceBetween
        ? parseInt(slider.dataset.mobileSpaceBetween)
        : spaceBetween;

      const tabletSpaceBetween = slider.dataset.tabletSpaceBetween
        ? parseInt(slider.dataset.tabletSpaceBetween)
        : spaceBetween;

      const tabletwideSpaceBetween = slider.dataset.tabletwideSpaceBetween
        ? parseInt(slider.dataset.tabletwideSpaceBetween)
        : spaceBetween;

      const desktopSpaceBetween = slider.dataset.desktopSpaceBetween
        ? parseInt(slider.dataset.desktopSpaceBetween)
        : spaceBetween;

      const wideSpaceBetween = slider.dataset.wideSpaceBetween
        ? parseInt(slider.dataset.wideSpaceBetween)
        : spaceBetween;

      const hugeSpaceBetween = slider.dataset.hugeSpaceBetween
        ? parseInt(slider.dataset.hugeSpaceBetween)
        : spaceBetween;

      const perView = slider.dataset.perView ? slider.dataset.perView : 1;

      const mobileSlidesPerView = slider.dataset.mobileSlidesPerView
        ? slider.dataset.mobileSlidesPerView
        : perView;

      const tabletSlidesPerView = slider.dataset.tabletSlidesPerView
        ? slider.dataset.tabletSlidesPerView
        : perView;

      const tabletwideSlidesPerView = slider.dataset.tabletwideSlidesPerView
        ? slider.dataset.tabletwideSlidesPerView
        : perView;

      const desktopSlidesPerView = slider.dataset.desktopSlidesPerView
        ? slider.dataset.desktopSlidesPerView
        : perView;

      const wideSlidesPerView = slider.dataset.wideSlidesPerView
        ? slider.dataset.wideSlidesPerView
        : perView;

      const hugeSlidesPerView = slider.dataset.hugeSlidesPerView
        ? slider.dataset.wideSlidesPerView
        : perView;

      const settings = {
        centeredSlides,
        effect: effect,
        fadeEffect: crossFade
          ? {
              crossFade: true,
            }
          : undefined,
        freeMode,
        autoplay: autoplay
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
            }
          : undefined,
        pagination: {
          el: '.o-slider-swiper__bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="o-slider-swiper__bullet ${className}"></span>`;
          },
        },
        navigation: {
          nextEl: '.o-slider-swiper__arrow--right',
          prevEl: '.o-slider-swiper__arrow--left',
        },
        loop,
        speed,
        slidesPerView: perView,
        spaceBetween: spaceBetween,
        breakpoints: {
          // when window width is >= 320px
          375: {
            slidesPerView: mobileSlidesPerView,
            spaceBetween: mobileSpaceBetween,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: tabletSlidesPerView,
            spaceBetween: tabletSpaceBetween,
          },
          // when window width is >= 1024px
          1024: {
            slidesPerView: tabletwideSlidesPerView,
            spaceBetween: tabletwideSpaceBetween,
          },
          // when window width is >= 1280px
          1280: {
            slidesPerView: desktopSlidesPerView,
            spaceBetween: desktopSpaceBetween,
          },
          // when window width is >= 1440px
          1440: {
            slidesPerView: wideSlidesPerView,
            spaceBetween: wideSpaceBetween,
          },
          // when window width is >= 1920px
          1920: {
            slidesPerView: hugeSlidesPerView,
            spaceBetween: hugeSpaceBetween,
          },
        },
      };

      const swiper = new Swiper(
        `.js-swiper-slider[data-gallery-name=${galleryName}]`,
        settings
      );
    }
  );
}

/**
 * Initialise sliders
 *
 * @export
 */
export function setupGalleries() {
  Array.from(document.querySelectorAll('.js-gallery')).forEach(
    (gallery, index) => {
      const galleryName = gallery.dataset.galleryName;

      const galleryMainSlider = gallery.querySelector('.c-gallery__slider');

      const autoplay = galleryMainSlider.dataset.autoplay === 'true';

      const loop = galleryMainSlider.dataset.loop === 'true';

      const effect = galleryMainSlider.dataset.effect
        ? galleryMainSlider.dataset.effect
        : undefined;

      const speed = galleryMainSlider.dataset.speed
        ? parseInt(galleryMainSlider.dataset.speed, 10)
        : 1000;

      const autoplaySpeed = galleryMainSlider.dataset.autoplaySpeed
        ? parseInt(galleryMainSlider.dataset.autoplaySpeed, 10)
        : 5000;

      const perView = galleryMainSlider.dataset.perView
        ? parseInt(galleryMainSlider.dataset.perView, 10)
        : 1;

      const mobileSlidesPerView = galleryMainSlider.dataset.mobileSlidesPerView
        ? parseInt(galleryMainSlider.dataset.mobileSlidesPerView, 10)
        : 1;

      const tabletSlidesPerView = galleryMainSlider.dataset.tabletSlidesPerView
        ? parseInt(galleryMainSlider.dataset.tabletSlidesPerView, 10)
        : 1;

      const settings = {
        centeredSlides: true,
        effect,
        autoplay: autoplay
          ? {
              delay: autoplaySpeed,
              disableOnInteraction: false,
            }
          : undefined,
        pagination: {
          el: '.o-slider-swiper__bullets',
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="o-slider-swiper__bullet ${className}"></span>`;
          },
        },
        navigation: {
          nextEl: '.c-gallery__slider__arrow--right',
          prevEl: '.c-gallery__slider__arrow--left',
        },
        loop,
        speed,
        slidesPerView: perView,
        breakpoints: {
          375: {
            slidesPerView: mobileSlidesPerView,
          },
          768: {
            slidesPerView: tabletSlidesPerView,
          },
          1280: {
            slidesPerView: perView,
          },
        },
      };

      const thumbsSlider = new Swiper(`.c-gallery__thumbs--${galleryName}`, {
        loop: true,
        spaceBetween: 4,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          375: {
            slidesPerView: 3,
          },
          768: {
            slidesPerView: 5,
          },
          1024: {
            slidesPerView: 7,
          },
        },
      });

      const swiperMain = new Swiper(
        `.js-gallery[data-gallery-name=${galleryName}] .c-gallery__slider`,
        {
          ...settings,
          thumbs: {
            swiper: thumbsSlider,
          },
        }
      );
    }
  );
}

export default { setupSwipers, setupGalleries };
